export default __webpack_public_path__ + "static/media/salary-image.6a00e415.svg";